import { generateEvidenceTracks } from './evidence.js';
import { generateExecutiveSummary } from './executive-summary.js';
import { generatePlanning } from './planning.js';
import { generateRecommendations } from './recommendations.js';
import { generateRoadmap } from './roadmap.js';
import { calculateQuickscanResult } from './scoring.js';
import { generateWhitepaperSections } from './whitepaper.js';
export function generateQuickscanReport(companyType, answers, options = {}) {
    const now = options.now ?? new Date();
    const result = calculateQuickscanResult(companyType, answers);
    const recommendations = generateRecommendations(companyType, answers);
    const planning = generatePlanning(recommendations);
    const roadmap = generateRoadmap({
        companyType,
        riskLevel: result.riskLevel,
        now,
    });
    const evidenceTracks = generateEvidenceTracks(companyType);
    const whitepaperSections = generateWhitepaperSections({
        companyType,
        riskLevel: result.riskLevel,
    });
    const executiveSummary = generateExecutiveSummary({
        result,
        recommendations,
        companyType,
        now,
    });
    const totalEstimatedCostMin = recommendations.reduce((sum, r) => sum + (r.estimatedCostMin ?? 0), 0);
    const totalEstimatedCostMax = recommendations.reduce((sum, r) => sum + (r.estimatedCostMax ?? 0), 0);
    const totalEffortDays = recommendations.reduce((sum, r) => sum + r.estimatedEffortDays, 0);
    return {
        result,
        recommendations,
        planning,
        totalEstimatedCostMin,
        totalEstimatedCostMax,
        totalEffortDays,
        executiveSummary,
        whitepaperSections,
        roadmap,
        evidenceTracks,
    };
}
//# sourceMappingURL=report.js.map